/**
 * Created by anatoly on 27.12.2024
 */

const MergeHintLogics = {
    type: "merge",
    priority: 7,

    chooseConfig: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const fix = location.getContinuousStage();

        if (fix >= 3) {
            return { delay: 3000, interval: 3000 };
        }

        if (fix >= 2) {
            return { delay: 3000, interval: 1000 };
        }

        return { delay: 3000, interval: 1000, finger: true };
    },

    findMove: function (withGrounded) {
        const config = this.chooseConfig();
        if (!config) {
            return;
        }

        if (!Merge2.current || !Merge2.current.isGameMode()) {
            return;
        }

        const cluster = this.collectCandidates(withGrounded);
        if (cluster.length === 0) {
            return;
        }

        const candidates = this.applyPriorities(cluster);
        const solution = PseudoRandom.GET().choose(candidates);

        return {
            type: this.type,
            finger: config.finger,
            delay: config.delay,
            interval: config.interval,
            cells: solution.cells
        };
    },

    collectCandidates: function (withGrounded, options) {
        options = options || {};
        const mark = options.mark || "customerMark";
        const units = Merge2.current.field.listAvailableUnits();
        const used = {};
        const cluster = [];

        units.forEach((unit) => {
            const key = Unit.GetPositionKey(unit);
            if (used[key] || unit.isGrounded() || unit[mark]) {
                return;
            }
            used[key] = true;

            const match = this.findMergePoint(unit, withGrounded, mark);
            if (!match) {
                return;
            }

            const mergeComponent = unit.findComponent(MergeComponent);
            const result = mergeComponent && mergeComponent.mergeUnit();

            cluster.push({
                needed: Boolean(result && Merge2.current.customers.isUnitNeeded(result)),
                withGrounded: match.grounded,
                mineable: Families[unit.code].type === "generator",
                stage: unit.stage,
                cells: [{ x: unit.x, y: unit.y }, match.point],
                unit
            });
        });

        return cluster;
    },

    findMergePoint: function (unit, withGrounded, mark) {
        let possibleMergePoint;
        let possibleMergeGrounded;

        Merge2.current.field.iterateBfs(unit.x, unit.y, (p) => {
            const otherUnit = Merge2.current.field.getUnit(p.x, p.y);
            const grounded = otherUnit && otherUnit.findComponent(Grounded);

            if (!otherUnit || possibleMergeGrounded || (p.x === unit.x && p.y === unit.y) || (grounded && !withGrounded) || otherUnit[mark]) {
                return;
            }

            if (unit.isMergeable(otherUnit) && otherUnit.isMergeable(unit)) {
                if (!possibleMergePoint || grounded) {
                    possibleMergePoint = p;
                    possibleMergeGrounded = Boolean(grounded);
                }
            }
        });

        if (!possibleMergePoint || (withGrounded && !possibleMergeGrounded)) {
            return null;
        }
        return { point: possibleMergePoint, grounded: possibleMergeGrounded };
    },

    applyPriorities: function (cluster) {
        let candidates = cluster;

        const needed = candidates.filter((s) => s.needed);
        if (needed.length) {
            candidates = needed;
        }

        const grounded = candidates.filter((s) => s.withGrounded);
        if (grounded.length) {
            candidates = grounded;
        }

        const mineable = candidates.filter((s) => s.mineable);
        if (mineable.length) {
            candidates = mineable;
        }

        let maxStage = -Infinity;
        for (let i = 0; i < candidates.length; i++) {
            if (candidates[i].stage > maxStage) {
                maxStage = candidates[i].stage;
            }
        }
        return candidates.filter((s) => s.stage === maxStage);
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(MergeHintLogics);